import * as React from 'react';
import {useGetNewsByIdQuery} from "../../services/news";
import {useParams} from "react-router";
import clsx from "clsx";
import {Link} from "react-router-dom";
import Moment from "moment";
import {Meta} from "../base/Meta";
import {PageNotFound} from "../404/404";
import {resizeSrc} from "../../utils/utils";
import {Loader} from "../loader/Loader";
import {BreadCrumbsBlock} from "../simple/BreadCrumbsBlock";


const NewsItem = ({ttp}: { ttp: string }): JSX.Element => {
    let {slug} = useParams();
    const {data: article, isSuccess, isLoading, isFetching, isError} = useGetNewsByIdQuery({
        slug: slug,
        ttp: ttp
    });
    if (isError) {
        return <PageNotFound/>
    }

    return (
        <>
            <div className="container">

                <div className={clsx("wrapper animate animateY", !isFetching && 'animated')}>
                    {
                        (isFetching) ? <Loader/> :
                            <>
                                <BreadCrumbsBlock items={[
                                    {name: 'Новости и акции', link: '/news'},
                                    {name: article.name, link: article.slug}
                                ]}/>
                                {
                                    (isSuccess) ?
                                        <section className="new-news-item new-news-item--state">
                                            <Meta title={article.name} {...article.metatags} />
                                            <div className="new-news-item__header">
                                                <h1 className="new-news-item__title">{article.name}</h1>
                                                <div className="new-news-item__control">
                                                    <time className="new-news-item__date new-news-item__date--iconed"
                                                          dateTime="2022-08-24T16:29">{Moment(article.created).format('DD MMMM YYYY')}</time>
                                                </div>
                                            </div>
                                            <div className="new-news-item__img-wrapper">
                                                <img src={resizeSrc(article.image, 1150, 600)} alt={article.name}/>
                                            </div>
                                            <div className="new-news-item__content">
                                                <div dangerouslySetInnerHTML={{__html: article.content}}/>
                                            </div>
                                            <div className={'more-block mt-20'}>
                                                <Link className='btn btn-yellow'
                                                      to={`/${ttp}`}>Все {(ttp == 'article' ? 'статьи' : 'новости и акции')}</Link>
                                            </div>
                                        </section> : null
                                }
                            </>
                    }


                </div>

            </div>
        </>
    );
};

export default NewsItem;

